// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fF","catalogByServiceItem__title":"c-k_fG"};